import AlertIconSmallRed from './AlertIconSmallRed';
export default AlertIconSmallRed;
